import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { nameofSubjectSchemaCollection, SubjectView } from "../Types/SubjectSchema";

export async function getAllSubjects(): Promise<SubjectView[]> {
    let subjects: SubjectView[] = [];
    const subjectQuery = query(collection(db, nameofSubjectSchemaCollection));
    const queryresult = await getDocs(subjectQuery);
    queryresult.forEach((doc) => {
        subjects.push(
            {
                Id: doc.id,
                SubjectName: doc.data().SubjectName
            } as SubjectView);
    });
    return subjects;
}

export async function getSubject(subjectId: string): Promise<SubjectView | undefined> {
    const subjectRef = doc(db, nameofSubjectSchemaCollection, subjectId);
    const subject = await getDoc(subjectRef);
    if (subject.exists()) {
        return {
            Id: subject.id,
            SubjectName: subject.data().SubjectName
        } as SubjectView;
    }
    return undefined;
}